var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_c('AddToBasketBtn',{staticClass:"basketBtn",attrs:{"item":_vm.item}}),_c('div',{staticClass:"preview",domProps:{"innerHTML":_vm._s(_vm.parsedPreview)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }